/**
 * Componente Modal
 * Wrapper para o Modal do Ant Design
 */

import React from "react";
import { Modal as AntModal } from "antd";

const Modal = ({
  isOpen,
  onClose,
  title,
  subtitle,
  children,
  size = "md",
  showCloseButton = true,
  closeOnOverlayClick = true,
  footer,
  className,
  zIndex,
  styles: modalStyles,
  classNames: modalClassNames,
}) => {
  const sizeMap = {
    sm: 520,
    md: 800,
    lg: 1000,
    xl: 1200,
    full: "100%",
  };

  const modalTitle =
    subtitle !== undefined && subtitle !== null && String(subtitle).trim() !== "" ? (
      <>
        {title}
        <div className="text-muted-foreground" style={{ fontSize: "0.875rem", fontWeight: "normal", marginTop: "4px" }}>
          {subtitle}
        </div>
      </>
    ) : (
      title
    );

  return (
    <AntModal
      open={isOpen}
      onCancel={onClose}
      title={modalTitle}
      footer={footer !== undefined ? footer : null}
      width={sizeMap[size] || 800}
      maskClosable={closeOnOverlayClick}
      closable={showCloseButton}
      className={className}
      zIndex={zIndex}
      styles={modalStyles}
      classNames={modalClassNames}
    >
      {children}
    </AntModal>
  );
};

export default Modal;
